import React from 'react';
import { targetQuantity, remainingQuantity, isLineComplete } from '../utils/loadingScan';
import '../styles/scanFeedback.css';

// Panel under the scanner inputs. The gun's Enter sequence never has to
// stop for it: it shows the line the code just identified (what the order
// needs, what is still missing) and then the receipt of the entry just
// registered, so the loader never hunts for the card in the grid.
function ScanFeedback({ identified, receipt, scannedQuantity, onUndo }) {
  if (identified) {
    const unit = identified.format_name;
    const verified = scannedQuantity(identified.sku_code);
    return (
      <section className="scan-feedback scan-feedback--identified" aria-label="Último escaneo" aria-live="polite">
        <div className="scan-feedback__head">
          <h2 className="scan-feedback__name">{identified.sku_name}</h2>
          <span className="scan-feedback__sku">SKU {identified.sku_code}</span>
        </div>
        <p className="scan-feedback__target">A cargar: {targetQuantity(identified)} {unit}</p>
        <div className="scan-feedback__facts">
          <p>Ya verificado: {verified} {unit}</p>
          <p>Falta: {remainingQuantity(identified, verified)} {unit}</p>
        </div>
      </section>
    );
  }

  if (receipt) {
    const { item, quantity } = receipt;
    const unit = item.format_name;
    const total = scannedQuantity(item.sku_code);
    const over = total - targetQuantity(item) > 1e-9;
    return (
      <section
        className={`scan-feedback ${over ? 'scan-feedback--over' : 'scan-feedback--registered'}`}
        aria-label="Último escaneo"
        aria-live="polite"
      >
        <span className="scan-feedback__badge">Registrado</span>
        <div className="scan-feedback__head">
          <h2 className="scan-feedback__name">{item.sku_name}</h2>
          <span className="scan-feedback__sku">SKU {item.sku_code}</span>
        </div>
        <p className="scan-feedback__target">Ingresado: {quantity} {unit}</p>
        <div className="scan-feedback__facts">
          <p>Total verificado: {total} / {targetQuantity(item)} {unit}</p>
        </div>
        {over ? (
          <p className="scan-feedback__warning">Supera lo pedido</p>
        ) : (
          isLineComplete(item, total) && <p className="scan-feedback__complete">Línea completa</p>
        )}
        <div className="scan-feedback__actions">
          <button type="button" className="scan-feedback__undo" onClick={onUndo}>
            Deshacer
          </button>
        </div>
      </section>
    );
  }

  return null;
}

export default ScanFeedback;
